import { actionTypes } from '@/services/actions/moderation';

// ==== 🗄️ Reducer
export const initialState = {
  loading: false,
  loadingCommentsCount: false,
  loadingCommentsFlaggingUsers: false,
  loadingModeration: false,
  error: false,

  pageSize: 25,
  state: 2, // pending
  tag: '',
  commentsFlaggingUsers: [],

  search_type: '',
  search_param: '',

  sort_dir: 1,

  commentsCount: {
    pending: 0,
    rejected: 0,
    approved: 0,
    flagged: 0,
  },
  tags: [],
  lastfetchCount: 0,

  moderations: [],

  mod_selects: [],

  commentThread: null,
  loadingThread: false,

  comment_active_users: [],
  comment_active_users_type: {},

  whitelisted_emails: [],
};

export const moderationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING: {
      return { ...state, loading: action.payload };
    }
    case actionTypes.SET_ERROR: {
      return { ...state, error: action.payload };
    }

    case actionTypes.SET_COMMENTSCOUNT: {
      return {
        ...state,
        commentsCount: action.payload,
        loadingCommentsCount: false,
      };
    }
    case actionTypes.LOAD_COMMENTSCOUNT: {
      return { ...state, loadingCommentsCount: true };
    }
    case actionTypes.FETCH_FLAGGING_USERS: {
      return {
        ...state,
        commentsFlaggingUsers: action.payload,
        loadingCommentsFlaggingUsers: false,
      };
    }
    case actionTypes.LOAD_FLAGGING_USERS: {
      return { ...state, loadingCommentsFlaggingUsers: true };
    }
    case actionTypes.SET_TAGS: {
      return { ...state, tags: action.payload };
    }
    case actionTypes.SET_MODERATIONS: {
      return { ...state, moderations: action.payload };
    }
    case actionTypes.SET_LASTFETCHCOUNT: {
      return { ...state, lastfetchCount: action.payload };
    }

    case actionTypes.SET_PAGESIZE: {
      return { ...state, pageSize: action.payload };
    }
    case actionTypes.SET_STATE: {
      return { ...state, state: action.payload };
    }
    case actionTypes.SET_TAG: {
      return { ...state, tag: action.payload };
    }
    case actionTypes.REFRESH_REQUEST:
      const dir = 1;
      const { moderations } = state;
      moderations.sort((m1, m2) =>
        m1.createdTimestamp > m2.createdTimestamp ? -dir : dir,
      );
      return {
        ...state,
        tag: '',
        search_type: '',
        search_param: '',
        pageSize: 25,
        sort_dir: dir,
        moderations,
      };
    case actionTypes.SET_SEARCH_PARAM: {
      return { ...state, search_param: action.payload };
    }
    case actionTypes.SET_SEARCH_TYPE: {
      return { ...state, search_type: action.payload };
    }
    case actionTypes.SET_SEARCH_TYPE_AND_PARAM: {
      const { type, param } = action.payload;
      return { ...state, search_type: type, search_param: param };
    }
    case actionTypes.SET_SORTDIR: {
      const dir = action.payload;
      const { moderations } = state;
      moderations.sort((m1, m2) =>
        m1.createdTimestamp > m2.createdTimestamp ? -dir : dir,
      );
      return { ...state, sort_dir: dir, moderations };
    }

    case actionTypes.SET_WHITELISTED_EMAILS_FOR_HOST: {
      return { ...state, whitelisted_emails: action.payload };
    }

    case actionTypes.SET_FILTER_PARAMS: {
      const { sort_dir } = action.payload;
      const { moderations } = state;
      if (sort_dir != state.sort_dir) {
        moderations.sort((m1, m2) =>
          m1.createdTimestamp > m2.createdTimestamp ? -sort_dir : sort_dir,
        );
      }
      return { ...state, ...action.payload, moderations };
    }

    case actionTypes.SET_COMMENTTHREAD: {
      return { ...state, commentThread: action.payload };
    }

    case actionTypes.LOAD_MODERATIONS: {
      return { ...state, loadingModeration: true };
    }

    case actionTypes.FETCH_MODERATIONS: {
      return { ...state, loadingModeration: false };
    }
    case actionTypes.SET_LOADINGTHREAD: {
      return { ...state, loadingThread: action.payload };
    }

    case actionTypes.SET_MOD_SELECTS: {
      return { ...state, mod_selects: action.payload };
    }

    case actionTypes.SET_COMMENT_ACTIVE_USERS_TYPE: {
      return { ...state, comment_active_users_type: action.payload };
    }
    case actionTypes.LOAD_COMMENT_ACTIVE_USERS: {
      return { ...state, comment_active_users: action.payload };
    }

    default:
      return state;
  }
};

export default moderationReducer;
